import { render, staticRenderFns } from "./BaseMediaSelectorBox.vue?vue&type=template&id=a99659aa&scoped=true&"
import script from "./BaseMediaSelectorBox.vue?vue&type=script&lang=js&"
export * from "./BaseMediaSelectorBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseMediaSelectorBox.vue?vue&type=style&index=0&id=a99659aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a99659aa",
  null
  
)

export default component.exports